<template>
  <div
    data-sidebar="menu-badge"
    class="absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums text-n-slate-11 select-none pointer-events-none peer-hover/menu-button:text-n-slate-12 peer-data-[active=true]/menu-button:text-n-blue-11 peer-data-[size=sm]/menu-button:top-1 peer-data-[size=default]/menu-button:top-1.5 peer-data-[size=lg]/menu-button:top-2.5 group-data-[collapsible=icon]:hidden"
  >
    <slot />
  </div>
</template>
